import { Component, OnInit } from '@angular/core'

import { SESSION_STORAGE_CONSTANTS_CAAS_CONTENT } from '../../../../constants/constant.content'
import { ObservableService } from '../../../services/observable-service/observable.service'

@Component({
  selector: 'sub-asset-filter',
  templateUrl: './sub-asset-filter.component.html',
  styleUrls: ['./sub-asset-filter.component.scss'],
})
export class SubAssetFilterComponent implements OnInit {
  selectedFilterByName: string
  fd3filtersList: any
  constructor(private observableService: ObservableService) {}
  ngOnInit(): void {
    this.observableService.viewFilterByClickValue.subscribe((value) => {
      this.viewFilterByClick(value)
    })
    const aemCassDataFromSession = sessionStorage.getItem(
      SESSION_STORAGE_CONSTANTS_CAAS_CONTENT,
    )
    const parsedCaasJson = JSON.parse(aemCassDataFromSession)
    this.fd3filtersList = parsedCaasJson.data.fd3filtersList.items[0]
  }
  viewFilterByClick(value: string) {
    this.selectedFilterByName = value
  }
}
